module.exports = __webpack_public_path__ + "img/success-icon.3b83502a.svg";